export const SERVICE_REQUEST_ICONS = {
  'ServiceRequest::OrientationCall': 'phone',
  'ServiceRequest::ResumeReview': 'document',
  'ServiceRequest::CoverLetterReview': 'document',
  'ServiceRequest::LinkedInReview': 'linkedin',
  'ServiceRequest::JobSearchStrategy': 'briefcase',
  'ServiceRequest::CareerPivotPlanning': 'target',
  'ServiceRequest::NetworkingStrategy': 'people',
  'ServiceRequest::InterviewPrep': 'interview',
  'ServiceRequest::MockInterview': 'chat',
  'ServiceRequest::NegotiationStrategy': 'dollar',
  'ServiceRequest::JobSearchBurnout': 'wellness',
  'ServiceRequest::OnboardingSupport': 'rocket',
  'ServiceRequest::RetirementSupport': 'retirement',
  'ServiceRequest::StrengthsAssessment': 'gym',
  'ServiceRequest::ExecutiveBio': 'pencil',
  'ServiceRequest::RecruiterTargeting': 'recruiting',
  'ServiceRequest::BoardSearch': 'network',
  'ServiceRequest::TargetCompanyResearch': 'target',
}
